import { hasAiAccess } from '../../utils/aiAccess';
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { NavLink } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { SETTINGS_CATEGORIES } from './settingsData';

const groups = [
  { title: 'Personal', keys: ['account', 'notifications', 'regional'] },
  { title: 'Workspace', keys: ['workspace', 'billing', 'custom-fields', 'business-knowledge'] },
  { title: 'WhatsApp & AI', keys: ['whatsapp'], whatsappOnly: true },
  { title: 'Help', keys: ['about'] },
  { title: 'Email', keys: ['email'], emailOnly: true },
];

const SettingsNav = ({ variant = 'sidebar' }) => {
  const { user } = useAuth();
  const isList = variant === 'list';

  return (
    <div className={isList ? 'space-y-3' : 'space-y-1'}>
      {groups.filter(group => (!group.whatsappOnly || user?.whatsappInboxEnabled) && (!group.emailOnly || user?.emailInboxEnabled)).map(group => <section key={group.title} className="space-y-1 pb-4">
        <h3 className="px-3 pb-2 text-xs font-semibold uppercase tracking-wider text-gray-500">{group.whatsappOnly && !hasAiAccess(user) ? 'WhatsApp' : group.title}</h3>
        {group.keys.map(key => SETTINGS_CATEGORIES.find(item => item.key === key)).map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.key}
            to={item.path}
            className={({ isActive }) => (
              isList
                ? `flex items-center justify-between px-3 py-2.5 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition-all active:scale-[0.98] ${isActive ? 'ring-2 ring-primary-500 ring-offset-1' : ''}`
                : `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-all ${isActive
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-gray-600 hover:bg-gray-100'
                }`
            )}
          >
            <div className={`flex items-center gap-3 ${isList ? '' : 'min-w-0'}`}>
              <div className={isList ? 'w-9 h-9 rounded-lg bg-primary-50 flex items-center justify-center' : 'w-5 h-5 flex items-center justify-center'}>
                <Icon className={isList ? 'w-5 h-5 text-primary-600' : 'w-4 h-4'} />
              </div>
              <div className={isList ? 'min-w-0' : 'truncate'}>
                <div className={`font-semibold text-gray-900 ${isList ? 'text-sm' : 'text-sm'}`}>
                  {item.label}
                </div>
                {isList && (
                  <div className="text-xs text-gray-500 line-clamp-1">
                    {item.description}
                  </div>
                )}
              </div>
            </div>
            {isList && (
              <ChevronRight className="w-4 h-4 text-gray-400" />
            )}
          </NavLink>
        );
      })}
      </section>)}
    </div>
  );
};

export default SettingsNav;
